import { Link, useLocation } from 'react-router';

import { useNavigationItems } from '~widgets/navigation';
import { ProfileMenu } from '~widgets/profile-menu';

import { ROUTES } from '~shared/config/routes';
import { Container } from '~shared/ui/layout';

import { Typography } from '@breezeventures/ui-kit/typography';

import { SkyroLogo } from './skyro-logo';

type NavLinkProps = {
  to: string;
  name: string;
  isActive: boolean;
};

const NavLink = ({ to, name, isActive }: NavLinkProps) => {
  return (
    <Link to={to} className="inline-flex items-center px-6 no-underline">
      <Typography.Text
        size="m"
        weight={isActive ? 'medium' : 'normal'}
        color="primary"
      >
        {name}
      </Typography.Text>
    </Link>
  );
};

export const Header = () => {
  const navigationItems = useNavigationItems();
  const { pathname } = useLocation();

  return (
    <header className="flex h-16 items-center bg-white py-3">
      <Container>
        <nav className="grid grid-cols-[1fr_auto_1fr] items-center">
          <Link to={ROUTES.root} className="w-fit shrink-0">
            <SkyroLogo />
          </Link>
          <ul className="flex list-none items-center">
            {navigationItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  name={item.label}
                  isActive={pathname.startsWith(item.to)}
                />
              </li>
            ))}
          </ul>
          <div className="flex justify-end">
            <ProfileMenu />
          </div>
        </nav>
      </Container>
    </header>
  );
};
